import { t } from "i18next"
import ValidationsCommon from "../../../utils/Validations";
const Validations = () => ({
    ...ValidationsCommon(),
});

export default Validations;